export default __webpack_public_path__ + "../sites/jinja2//site/svg/risang/location-search.svg";